import { useStore } from '../store';

export const isUserLoggedIn = () => {
  const { profile } = useStore.getState();
  return !!profile?.id;
};
